<template>
  <chart :chart-options="chartOptions" />
</template>

<script>
import Highcharts from 'highcharts'
import HighchartsFormattingWrapper from './HighchartsFormattingWrapper'

export default {
  name: 'PieChart',
  components: {
    chart: HighchartsFormattingWrapper
  },
  props: {
    chartData: { type: Object, default: () => ({}) },
    title: { type: String, default: null },
    categoryName: { type: String, default: '' }
  },
  computed: {
    colors () {
      const colors = []
      const base = Highcharts.getOptions().colors[0]
      let i

      for (i = 0; i < 10; i += 1) {
        // Start out with a darkened base color (negative brighten), and end
        // up with a much brighter color
        colors.push(Highcharts.color(base).brighten((i - 3) / 7).get())
      }
      return colors
    },
    series () {
      return Object.entries(this.chartData)
        .sort((a, b) => a[1] - b[1])
        .reduce((s, [key, value]) => {
          s[0].data.push({ name: key, y: value })
          return s
        }, [{ name: this.categoryName, colorByPoint: true, data: [] }])
    },
    chartOptions () {
      return {
        chart: {
          type: 'pie'
        },
        title: {
          text: this.title
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            colors: this.colors,
            size: 150,
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>:{point.percentage:.1f} %'
            }
          }
        },
        series: this.series
      }
    }
  }
}
</script>
